import classNames from 'classnames';
import { ArrowDown, Check } from 'components/Icons';
import { Menu, MenuItem, Dropdown, Radio } from 'components-antd';
import styles from './styles.module.scss';
import { TabLabel } from '../../components/TabLabel';

export const ArchiveDropdown = (props) => {
  const { dropdownOptions, archivedData, archivedValue, setArchivedValue, tabCount } = props;

  const menu = (
    <div>
      <Radio.Group
        onChange={(event) => setArchivedValue(event.target.value)}
        value={archivedValue}
        className={styles.optionsItems}
      >
        <Menu>
          <MenuItem className={styles.archiveMenuItem}>Archive</MenuItem>
          {dropdownOptions.map((item, idx) => {
            return (
              <MenuItem key={item.label}>
                <Radio value={item.label} key={idx}>
                  <div className={styles.option}>
                    <span className={styles.optionValue}>
                      <TabLabel title={item.label} count={item.count} />
                    </span>
                  </div>
                  {archivedValue === item.label && <Check className={styles.checkIcon} />}
                </Radio>
              </MenuItem>
            );
          })}
        </Menu>
      </Radio.Group>
    </div>
  );

  return (
    <div className={styles.filterWrap}>
      <Dropdown
        overlay={menu}
        placement="bottom"
        getPopupContainer={(triggerNode) => triggerNode}
        trigger={['click']}
        overlayClassName={styles.archiveFilterDropdown}
      >
        <a
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          className={classNames(styles.filterButton, 'mosaikDropdownButton')}
        >
          <span className={styles.archiveText}>
            {archivedValue ? (
              <TabLabel title={archivedValue} count={tabCount || archivedData.length} />
            ) : (
              'Archive'
            )}
          </span>
          <ArrowDown className={classNames(styles.icon, { [styles.open]: open })} size={16} />
        </a>
      </Dropdown>
    </div>
  );
};
